
import { onMounted, ref } from 'vue'
import { RouteLocationMatched } from 'vue-router'
import router from '@/router'

export default {
  name: 'AppBreadcrumb',
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  setup() {
    const breadcrumbs = ref()

    const getBreadcrumbs = () => {
      return router.currentRoute.value.matched.map(
        (route: RouteLocationMatched) => {
          let adjustedPath = route.path
          if (adjustedPath.includes('/:id')) {
            adjustedPath = adjustedPath.replace('/:id', '')
          }
          return {
            active: route.path === router.currentRoute.value.fullPath,
            name: route.name,
            path: `${router.options.history.base}${adjustedPath}`,
          }
        },
      )
    }

    router.afterEach(() => {
      breadcrumbs.value = getBreadcrumbs()
    })

    onMounted(() => {
      breadcrumbs.value = getBreadcrumbs()
    })

    return {
      breadcrumbs,
    }
  },
}
